import styled from "styled-components";

const Container = styled.div`
    border: solid 1px #e6e6e6; 
    border-radius: 4px;
    padding: 20px 30px;
    margin: 10px 0
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: bold;
`;

export { Container, Title };


// WEBPACK FOOTER //
// ./src/components/report/individual_user/style.js